const adminIdp = {
  actions: {
    backToClients: '返回 Clients',
    backToClientScopes: '返回 Client Scopes',
    cancel: '取消',
    closeAnyway: '仍然关闭',
    continueSaving: '继续保存',
    copy: '复制',
    create: '创建',
    delete: '删除',
    done: '我已保存',
    edit: '编辑',
    manageClientScopes: '管理 Client Scopes',
    rotateKey: '轮换 Signing Key',
    rotateSecret: '确认轮换',
    save: '保存',
  },
  breadcrumbs: {
    label: '页面层级',
  },
  description:
    '开启后，下游系统就能通过 Hub 登录。接入地址可在本页复制，Client 请前往 Clients 页面管理。',
  errors: {
    rotateKey: 'Signing Key 轮换失败。',
    save: 'OIDC Provider 状态保存失败。',
  },
  loadFailed: 'OIDC Identity Provider 配置加载失败。',
  parameters: {
    authorizationEndpoint: 'Authorization Endpoint',
    discoveryUrl: 'Discovery URL',
    hint: '这些地址由系统自动生成，配置下游系统时直接复制即可。',
    introspectionEndpoint: 'Introspection Endpoint',
    issuer: 'Issuer',
    jwksUri: 'JWKS URI',
    oauthDiscoveryUrl: 'OAuth Authorization Server Metadata',
    revocationEndpoint: 'Revocation Endpoint',
    title: 'Provider 参数',
    tokenEndpoint: 'Token Endpoint',
    userinfoEndpoint: 'UserInfo Endpoint',
  },
  provider: {
    hint: '关闭后保留 Discovery 与 JWKS，只停止 authorize、token、userinfo 和静默 session 建立。',
    title: 'OIDC Provider',
    toggle: '启用 OIDC Provider',
  },
  signingKey: {
    confirmTitle: '轮换 Signing Key',
    hint: '仅在密钥泄露或计划轮换时操作；旧公钥会暂时保留，以验证尚未过期的 ID Token。',
    rotateConfirm: '确定立即轮换 Signing Key 吗？新 ID Token 会立刻使用新密钥，下游必须刷新 JWKS。',
    title: 'Signing Key',
  },
  status: { disabled: '已停用', enabled: '已启用' },
  success: {
    disabled: 'OIDC Provider 已关闭',
    enabled: 'OIDC Provider 已开启',
    keyRotated: 'Signing Key 已轮换：{{kid}}',
  },
  title: 'OIDC Identity Provider',
  setupFlow: {
    label: 'Identity Provider 配置顺序',
    steps: {
      provider: { title: '启用 Provider', description: '确认 Issuer 与协议端点' },
      scopes: { title: '定义 Scopes', description: '配置权限名与身份字段' },
      resources: { title: '登记 MCP Resources', description: '绑定 MCP Server 与允许的 scopes' },
      clients: { title: '接入 Clients', description: '签发 client 凭据并配置回调' },
    },
  },
  clients: {
    applicationBoundElsewhere: '已绑定到另一个 Client',
    applicationsDescription:
      '一个 Client 可以绑定多个 Hub Embed URL 应用；单个应用当前只能选择一个 Client。',
    clientScopesDescription:
      '勾选需要分配给 Client 的字段分组。Default Scope 自动返回，Optional Scope 仅在下游显式请求时返回。',
    confirmDelete: '确定删除 Client“{{name}}”吗？已绑定应用会同时解除绑定。',
    confirmDeleteTitle: '删除 Client',
    create: '创建 Client',
    description:
      '每个 Client 代表一个接入 Hub OIDC 的信任关系。先创建并把凭据交给对方，再按需绑定 Hub 应用。',
    detailTitle: 'OIDC Client',
    editTitle: '编辑 / {{name}}',
    empty: '暂无 OIDC Client。',
    noApplications: '暂无 Embed URL 应用。',
    search: '搜索 Client 名称、Client ID 或应用',
    title: 'Clients',
    clientKinds: {
      mcpOauth: 'MCP OAuth',
      oidcEmbed: 'OpenID Connect',
    },
    columns: {
      actions: '操作',
      applications: '应用',
      clientId: 'Client ID',
      clientKind: 'Client 类型',
      name: '名称',
      protocol: '协议',
      scopes: 'Scopes',
      status: '状态',
    },
    credentials: {
      closeConfirm: '完整接入包尚未复制，确定关闭吗？关闭后将无法再次查看 Client Secret。',
      closeConfirmTitle: 'Client 凭据尚未保存',
      copyFailed: '复制失败，请检查剪贴板权限后重试。',
      copyPackage: '复制完整接入包',
      copySuccess: '已复制到剪贴板。',
      notConfigured: '尚未配置',
      oneTimeHint: 'Client Secret 只显示这一次。请立即安全保存并交付给下游系统。',
      protocol: '协议要求',
      providerLoadFailed: 'Provider 参数加载失败，Client Secret 仍保留在当前窗口中。',
      providerLoading: '正在加载 Provider 参数…',
      retryProvider: '重试',
      rotate: '轮换 Client Secret',
      rotateConfirm: '确定轮换 Client Secret 吗？旧 Secret 会立即失效。',
      rotateConfirmTitle: '轮换 Client Secret',
      rotateHint: '轮换后必须把新 Secret 更新到下游系统，否则现有登录会失败。',
      rotateTitle: 'Client Secret',
      title: '保存 Client 凭据',
    },
    errors: {
      create: '创建 Client 失败。',
      delete: '删除 Client 失败。',
      load: 'Client 列表加载失败。',
      loadDetail: 'Client 详情加载失败。',
      noActiveResources: '请先创建并启用一个 OAuth Resource。',
      noEnabledScopes: '请先创建并启用一个 Client Scope。',
      rotateSecret: 'Client Secret 轮换失败。',
      update: '保存 Client 失败。',
    },
    filters: {
      allClientKinds: '全部 Client 类型',
      clientKind: 'Client 类型',
    },
    fields: {
      assignScope: '分配 {{name}}',
      allowedScopes: '允许的 Client Scopes',
      allowedScopesHint: '动态 MCP client 只能为此 Resource 请求这里选择的 scopes。',
      authMethod: 'Token Endpoint 认证方式',
      authMethodHelp: '下游拿 Client Secret 换 token 的方式。大多数系统保持默认即可。',
      callbackUrls: 'Callback URL',
      callbackUrlsHelp:
        '下游登录完成后接收结果的地址。创建时可不填；联调前由下游提供，生产环境用 HTTPS。',
      clientKind: 'Client 类型',
      clientKindHelp: 'Embed 应用使用 OpenID Connect；访问 MCP Server 的外部系统使用 MCP OAuth。',
      defaultScopes: 'Default Client Scopes',
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      resource: 'OAuth Resource',
      resourceHint: '这个 Client 获得的 access token 只能用于所选 Resource URI。',
      name: 'Client 名称',
      nameHelp: '给管理员看的名称，用来区分不同下游系统或环境。',
      scope: 'Scope',
      scopeFallbackDescription: '此 scope 暂无说明。',
      scopeAssignment: '{{name}} 的分配方式',
      status: '状态',
      statusHelp: '停用后这个 Client 不能登录，但配置和绑定关系会保留。',
    },
    formHints: {
      mcp: '外部 MCP client 使用 Authorization Code + PKCE 获取绑定到单一 Resource 的 access token。',
      oidc: 'Hub Embed 应用使用 OpenID Connect 登录，并按 Client Scope 返回身份 claims。',
    },
    placeholders: {
      callbackUrls: 'https://client.example.com/oidc/callback',
      name: '例如：生产环境 Web Client',
    },
    rowActions: {
      edit: '编辑信息',
      open: '打开 {{name}} 的操作菜单',
    },
    scopeAssignments: {
      default: 'Default',
      optional: 'Optional',
      unassigned: '不分配',
    },
    success: {
      created: 'Client 已创建。',
      deleted: 'Client 已删除。',
      secretRotated: 'Client Secret 已轮换。',
      updated: 'Client 已保存。',
    },
    tabs: {
      applications: 'Applications',
      clientScopes: 'Client Scopes',
      credentials: 'Credentials',
      label: 'Client 详情页签',
      settings: 'Settings',
    },
  },
  resources: {
    confirmDelete: '确定删除 OAuth Resource“{{name}}”吗？仍被 Client 使用时系统会拒绝删除。',
    confirmDeleteTitle: '删除 OAuth Resource',
    confirmRotate: '确定轮换“{{name}}”的 Introspection Secret 吗？旧 Secret 会立即失效。',
    confirmRotateTitle: '轮换 Introspection Secret',
    create: '创建 OAuth Resource',
    description:
      '每个 Resource 代表一个受 Hub 保护的 MCP Server，并拥有独立的 introspection credential。',
    formHint:
      'Resource 是 access token 的唯一受众。创建后把一次性 introspection credential 安全交付给对应 MCP Server。',
    insecureHttpBadge: '非安全 HTTP',
    insecureHttpWarning:
      'HTTP 不提供传输加密，Bearer token 可能被监听或篡改。仅可在显式开启的隔离开发或 UAT 私网中临时使用，生产前必须迁移到 HTTPS。',
    editTitle: '编辑 / {{name}}',
    empty: '暂无 OAuth Resource。',
    search: '搜索名称、Resource URI 或 Introspection Client ID',
    title: 'OAuth Resources',
    columns: {
      actions: '操作',
      introspectionClientId: 'Introspection Client ID',
      name: '名称',
      resourceUri: 'Resource URI',
      status: '状态',
    },
    credentials: {
      closeConfirm:
        '完整 Resource Server 接入包尚未复制，确定关闭吗？关闭后将无法再次查看 Secret。',
      closeConfirmTitle: 'Resource Server 凭据尚未保存',
      copyFailed: '复制失败，请检查剪贴板权限后重试。',
      copyPackage: '复制 Resource Server 接入包',
      oneTimeHint: 'Introspection Secret 只显示这一次。请立即安全保存并交付给 MCP Server。',
      providerLoadFailed: 'Provider 参数加载失败，Introspection Secret 仍保留在当前窗口中。',
      providerLoading: '正在加载 Provider 参数…',
      retryProvider: '重试',
      title: '保存 Resource Server 凭据',
    },
    errors: {
      create: '创建 OAuth Resource 失败。',
      delete: '删除 OAuth Resource 失败；请确认它没有被 Client 使用。',
      load: 'OAuth Resource 列表加载失败。',
      rotateSecret: 'Introspection Secret 轮换失败。',
      update: '保存 OAuth Resource 失败。绑定 Client 后不能修改 Resource URI。',
    },
    fields: {
      allowedScopes: '允许的 Client Scopes',
      allowedScopesHint: '只有这里选中的 scopes 才能用于签发面向此 Resource 的 access token。',
      introspectionClientId: 'Introspection Client ID',
      introspectionSecret: 'Introspection Secret',
      name: 'Resource 名称',
      nameHint: '仅供管理员识别，建议包含用途和环境，例如“知识库 MCP · UAT”。',
      noAvailableScopes: '暂无可用 Scope，请先创建并启用 Client Scope。',
      resourceUri: 'Resource URI',
      resourceUriHint: '生产环境使用稳定 HTTPS URI；绑定 Client 后不能修改。',
      scopeFallbackDescription: '此 scope 暂无说明。',
      status: '状态',
      statusHint: '停用后将阻止新授权；现有 token 也会在 introspection 时失效。',
    },
    placeholders: {
      name: '例如：知识库 MCP Server',
      resourceUri: 'https://mcp.example.com',
    },
    rowActions: {
      open: '打开 {{name}} 的操作菜单',
      rotateSecret: '轮换密钥',
    },
    success: {
      created: 'OAuth Resource 已创建。',
      deleted: 'OAuth Resource 已删除。',
      secretRotated: 'Introspection Secret 已轮换。',
      updated: 'OAuth Resource 已保存。',
    },
  },
  clientScopes: {
    builtIn: '内置',
    builtInReadOnly: '此 Client Scope 由系统维护，不允许修改或删除。',
    builtInReadOnlyTitle: '系统内置配置',
    confirmDelete: '确定删除 Client Scope“{{name}}”吗？',
    confirmDeleteTitle: '删除 Client Scope',
    create: '创建 Client Scope',
    createHint:
      '一个 Client Scope 表示一组可申请的权限与随之释放的身份字段。先定义 scope 名，再进入详情配置字段映射。',
    custom: '自定义',
    description:
      'Client Scope 是可复用的字段分组。先在 Scope 中配置 Protocol Mapper，再由应用整体选择为 Default 或 Optional。',
    detailTitle: 'Client Scope',
    empty: '暂无 Client Scope。',
    search: '搜索 Client Scope',
    title: 'Client Scopes',
    columns: {
      actions: '操作',
      description: '说明',
      mappers: 'Mappers',
      name: '名称',
      protocol: '协议',
      status: '状态',
      type: '类型',
    },
    errors: {
      create: '创建 Client Scope 失败。',
      delete: '删除 Client Scope 失败。',
      load: 'Client Scope 列表加载失败。',
      loadDetail: 'Client Scope 详情加载失败。',
      update: '保存 Client Scope 失败。',
    },
    fields: {
      description: '说明',
      descriptionHint:
        '说明这个 scope 授权了什么能力，方便 Client 与 Resource 管理员判断是否应该分配。',
      displayName: '显示名称',
      displayNameHint: '给管理员看的名称；系统会据此尝试生成 Scope 名称。',
      enabled: '启用',
      includeInTokenScope: '在 token 响应中返回 Scope',
      includeInTokenScopeHint: '开启后，token 响应的 scope 字段会包含这个 Client Scope。',
      name: 'Scope 名称',
      nameHint: 'OAuth 请求中的机器可读值，例如 documents.read；创建后应保持稳定。',
    },
    placeholders: {
      description: '例如：允许读取当前用户可访问的文档，并释放必要的身份字段。',
      name: '例如 documents.read',
    },
    rowActions: {
      open: '打开 {{name}} 的操作菜单',
    },
    success: {
      created: 'Client Scope 已创建。',
      deleted: 'Client Scope 已删除。',
      updated: 'Client Scope 已保存。',
    },
    tabs: {
      label: 'Client Scope 详情页签',
      mappers: 'Mappers',
      settings: 'Settings',
    },
  },
  mappers: {
    claimSources: {
      email: '邮箱地址',
      external_person_id: '来源系统人员 ID',
      job_title: '职务',
      name: '成员姓名',
      organization_unit_codes: '所属组织代码',
      organization_unit_names: '所属组织名称',
      person_types: '人员类型',
      phone_number: '电话号码',
    },
    addRow: '添加一行',
    confirmDelete: '确定删除 Mapper“{{name}}”吗？',
    confirmDeleteTitle: '删除 Mapper',
    create: '添加 Mapper',
    createTitle: '新增字段映射',
    description: 'Mapper 决定身份数据如何写入 ID Token、UserInfo 或 Introspection。',
    edit: '编辑 Mapper',
    editTitle: '编辑字段映射',
    empty: '当前 Client Scope 还没有 Mapper。',
    emptyHint: '添加字段映射后，Hub 才会在选定的 token 或 introspection 响应中释放对应 claim。',
    formDescription: '选择来源后，Hub 会自动补齐名称、claim 名称与 JSON 类型；必要时仍可覆盖。',
    inlineDescription: '直接在表格中添加或修改字段映射；每次保存一行。',
    readOnlyDescription: '内置 Client Scope 的字段映射由系统维护，仅供查看。',
    rowActions: {
      open: '打开 {{name}} 的操作菜单',
    },
    sections: {
      behavior: '状态与预览',
      behaviorDescription: '控制当前 Mapper 是否生效，并检查这个字段的 claim shape。',
      destinations: '返回位置',
      destinationsDescription: '选择当前字段会写入哪些协议响应。',
      mapping: '字段映射',
      mappingDescription: '定义一个身份来源或固定值如何转换成协议 claim。',
    },
    title: 'Protocol Mappers',
    columns: {
      claimOutput: 'Claim 输出',
      destinations: '返回位置',
      mappingSource: '映射来源',
      name: '名称',
      source: '身份字段来源',
      status: '状态',
      tokenClaim: 'Token Claim',
      type: '类型',
      valueType: '值类型',
    },
    errors: {
      create: '创建 Mapper 失败。',
      delete: '删除 Mapper 失败。',
      update: '保存 Mapper 失败。',
    },
    fields: {
      addToIdToken: '写入 ID Token',
      addToIntrospection: '写入 Introspection',
      addToUserinfo: '写入 UserInfo',
      claimJsonType: 'JSON 值类型',
      enabled: '启用',
      hardcodedValue: '固定值',
      name: 'Mapper 名称',
      outputPreset: '返回位置预设',
      source: '身份字段来源',
      tokenClaimName: 'Token Claim 名称',
      type: 'Mapper 类型',
    },
    destinations: {
      idToken: '供 OpenID Connect client 在登录结果中识别用户。',
      introspection: '供 MCP Resource Server 在校验 opaque access token 时读取。',
      userinfo: '供 OpenID Connect client 按 access token 查询用户身份。',
    },
    hints: {
      autoValueType: '由所选身份字段的 schema 自动确定，避免数组被错误输出成字符串。',
      claimJsonType: '固定值在响应中的 JSON 类型。string_array 使用英文逗号分隔。',
      enabled: '停用后保留配置，但不再把这个 claim 写入任何响应。',
      hardcodedValue: '所有获得此 scope 的用户都会收到相同的固定值。不要在这里填写 secret。',
      name: '管理界面中的说明性名称，不会出现在协议响应里。',
      outputPreset: '先选常见场景，再按需微调下面三个输出位置。',
      source: '只能选择 Hub 已登记且允许通过 OIDC 释放的身份字段。',
      tokenClaimName: '响应 JSON 中的字段名，例如 department；不要使用 sub、scope 等保留名称。',
      type: '身份字段从当前登录账号读取；固定 Claim 为所有用户返回相同配置值。',
    },
    origins: {
      account: '账号字段',
      account_attribute: '账号扩展字段',
      organization: '组织关系',
      organization_attribute: '组织扩展字段',
    },
    outputPresets: {
      all: '全部位置',
      custom: '自定义',
      mcp: 'MCP · Introspection',
      oidc: 'OIDC · ID Token + UserInfo',
    },
    placeholders: {
      hardcodedValue: '输入固定值',
      name: '例如 Department',
      source: '选择身份字段',
      tokenClaimName: '例如 department',
    },
    sourcePicker: {
      empty: '没有匹配的身份字段',
      searchLabel: '搜索身份字段',
      searchPlaceholder: '搜索字段名称或来源路径',
    },
    success: {
      created: 'Mapper 已创建。',
      deleted: 'Mapper 已删除。',
      updated: 'Mapper 已保存。',
    },
    preview: {
      description:
        '这里只预览当前 Mapper 的单个 claim，不代表整个 Client Scope 的最终 payload，也不包含真实用户数据。',
      title: '当前字段预览',
    },
    types: {
      hardcoded_claim: '固定 Claim',
      hardcodedClaim: '固定 Claim',
      identity_source: '身份字段',
      identitySource: '身份字段',
    },
    validation: {
      required: '请补齐必填项，并至少选择一个返回位置。',
    },
    valueTypes: {
      boolean: 'Boolean',
      number: 'Number',
      string: 'String',
      string_array: 'String Array',
    },
  },
}

export default adminIdp
